import Layout from "../../components/Layout";
import AdminCollectionTable, { formatMoney } from "../../components/AdminCollectionTable";
import { productTypeLabel, PRODUCT_STATUS_OPTIONS, PRODUCT_TYPE_OPTIONS } from "../../lib/productEnums";
import { ProductStatusPill } from "../../components/ProductStatusPill";

// Column mapping verified against /app/backend/product.json (full production sample).
// Do NOT swap `BCProduct.price` for `BCProduct.val` etc. — those are earlier misleading abbreviations.
const COLUMNS = [
  { key: "sku",           label: "SKU",           path: "BCProduct.sku",                      sortable: true, sortPath: "BCProduct.sku" },
  { key: "brand",         label: "Brand Name",    path: "TMProduct.BrandName",                sortable: true, sortPath: "TMProduct.BrandName" },
  { key: "name",          label: "Title",         path: "BCProduct.name",                     sortable: true, sortPath: "BCProduct.name" },
  { key: "type",          label: "Type",          path: "TMProduct.ProductType",              sortable: true, sortPath: "TMProduct.ProductType", formatter: productTypeLabel },
  { key: "status",        label: "Status",        path: "TMProduct.Status",                   sortable: true, sortPath: "TMProduct.Status",      formatter: (v) => <ProductStatusPill value={v} /> },
  { key: "cost_price",    label: "Cost Price",    path: "BCProduct.cost_price",               sortable: true, sortPath: "BCProduct.cost_price",  formatter: formatMoney },
  { key: "price",         label: "Sell Price",    path: "BCProduct.price",                    sortable: true, sortPath: "BCProduct.price",       formatter: formatMoney },
  { key: "availability",  label: "Availability",  path: "BCProduct.availability_description", sortable: true, sortPath: "BCProduct.availability_description" },
];

const FILTERS = [
  { key: "type",   label: "Types",    param: "product_type", options: PRODUCT_TYPE_OPTIONS },
  { key: "status", label: "Statuses", param: "status",       options: PRODUCT_STATUS_OPTIONS },
];

export default function ProductManagement() {
  return (
    <Layout>
      <AdminCollectionTable
        collectionName="products"
        title="Products"
        subtitle="Active and Visible Products"
        columns={COLUMNS}
        alphaField="BCProduct.name"
        filters={FILTERS}
      />
    </Layout>
  );
}
